// extracted by mini-css-extract-plugin
export default {"main":"app_main__E1b33","navigation":"app_navigation__y1Wzv","mainAppBlock":"app_mainAppBlock__VuSDd","header":"app_header__07brU","content":"app_content__l--KZ"};